export const DIRECTION_ARRIVE = "arrive";
export const DIRECTION_FLIGHT = "flight";

export const CARRIER_RYANAIR = "ryanair";
export const CARRIER_WIZZAIR = "wizzair";
export const CARRIER_NORWEGIAN = "norwegian";
export const CARRIER_LOT = "lot";
export const CARRIER_LUFTHANSA = "lufthansa";
export const CARRIER_BRITISH_AIRWAYS = "british_airways";
export const CARRIER_AIR_FRANCE = "air_france";
export const CARRIER_KLM_ROYAL_DUTCH_AIRLINES = "klm_royal_dutch_airlines";
export const CARRIER_SWISS_INTERNATIONAL_AIR_L = "swiss_international_air_lines";
export const CARRIER_AUSTRIAN_AIRLINES = "austrian_airlines";
export const CARRIER_SAS_SCANDINAVIAN_AIRLINES = "sas_scandinavian_airlines";

export const DEPARTURE = "departure";
export const RETURN = "return";
